module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/packages/yofoui/customized/uploadformimage/asset/add.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/packages/yofoui/customized/uploadformimage/asset/add.png
// module id = 549
// module chunks = 367